export default {
  opportunities_boards: { 
    name: 'Boards de Oportunidades',
    menu: 'Boards de Oportunidades'
   },
  overview: { 
    name: 'Dashboard - Visão Geral',
    menu: 'Visão Geral' 
  },
  qualification: { 
    name: 'Dashboard - Qualificação',
    menu: 'Qualificação' 
  },
  prospecting: { 
    name: 'Dashboard - Prospecção',
    menu: 'Prospecção' 
  },
  monitoring: { 
    name: 'Dashboard - Monitoramento',
    menu: 'Monitoramento' 
  },
  opportunities: { 
    name: 'Negócios > Oportunidades',
    menu: 'Oportunidades' 
  },
  scanner_settings: {
    name: 'Capacidade do Scanner',
    menu: 'Capacidade do Scanner',
  },
  serviceBoards: {
    menu: 'Modelos',
    catalog: 'Modelos de Board',
  },
  boardFields: {
    menu: 'Campos',
    catalog: 'Campos de Board',
  },
  contactChannels: {
    menu: 'Canais',
    catalog: 'Canais de contato',
  },
  blog: {
    name: 'Artigos de Blog',
    menu: 'Artigos',
  },
  auth: { 
    name: 'Autenticação',
    menu: 'Autenticação'
  },
  board:{
    name: 'Board',
    menu: 'Board',
  },
  boardsConfigurable: {
    name: 'Boards Configuráveis',
    menu: 'Boards Configuráveis',
    catalog: 'Boards Configuráveis',
    description: 'Em breve',
  },
  candidates: {
    name: 'Candidatos a Prospecção',
    menu: 'Empresas',
    catalog: 'Inteligência Comercial',
    description: 'Deixe nosso sistema encontrar, investigar e priorizar empresas com potencial comercial enquanto você mantém o foco na sua operação.',
  },
  categories: {
    name: 'Serviços (Domínios)',
    catalog: 'Categorias de domínios e módulos',
    menu: 'Serviços',
    description: 'Categorias de domínios para controle de módulos, navegação e estruturação do catálogo de produtos da plataforma.'
  },
  channelAccounts: {
    menu: 'Contas de Canal'
  },
  cms_categories: {
    name: 'Categorias de Página',
    menu: 'Categorias'
  },
  cms_pages: {
    name: 'Páginas',
    menu: 'Páginas'
  },
  cms_products: {
    name: 'Produtos da Empresa',
    menu: 'Produtos'
  },
  context: { 
    name: 'Contexto do Site',
    menu: 'Contexto do Site' 
  },
  currencies: { 
    name: 'Moedas',
    menu: 'Moedas' 
  },
  dashboard_scan_monitoring: { 
    name: 'Monitoramento (Dashboard)',
    menu: 'Monitoramento' 
  },
  domains: {
    name: 'Domínios',
    menu: 'Domínios'
  },
  features: {
    name: 'Features',
    menu: 'Features'
  },
  invoices: { 
    name: 'Faturas',
    menu: 'Faturas' 
  },
  cms_layouts: {
    name: 'Layouts',
    menu: 'Layouts'
  },
  fonts: {
    name: 'Fontes',
    menu: 'Fontes'
  },
  modules: {
    name: 'Módulos',
    menu: 'Módulos'
  },
  modulePrices: { 
    name: 'Preços de Módulos',
    menu: 'Preços de Módulos' 
  },
  mfa: { 
    name: 'Autenticação Multifator',
    menu: 'Autenticação Multifator' 
  },
  notify: { 
    name: 'Notificações',
    menu: 'Notificações' 
  },
  offers: {
    name: 'Ofertas Comerciais',
    menu: 'Ofertas Comerciais',
  },
  pages: {
    name: 'Páginas',
    menu: 'Páginas'
  },
  page_types: {
    name: 'Tipos de Página',
    menu: 'Tipos de Página'
  },
  permissions: {
    name: 'Permissões',
    menu: 'Permissões'
  },
  payments: { 
    name: 'Pagamentos',
    menu: 'Pagamentos' 
  },
  product_modules: { 
    name: 'Módulos da Aplicação',
    menu: 'Módulos da Aplicação' 
  },
  profile: { 
    name: 'Meu Perfil',
    menu: 'Meu Perfil' 
  },
  provisioning: { 
    name: 'Provisionamento',
    menu: 'Provisionamento' 
  },
  products: {
    name: 'Aplicações',
    menu: 'Aplicações'
  },
  menus: {
    name: 'Menus de Acesso',
    menu: 'Menus de Acesso'
  },
  providers: {
    name: 'Provedores',
    menu: 'Provedores'
  },
  roles: {
    name: 'Perfis',
    menu: 'Perfis'
  },
  schedules: {
    name: 'Sistemas',
    menu: 'Sistemas',
    catalog: 'Agendamentos do Sistema',
  },
  scan_monitoring: { 
    name: 'Monitoramento',
    menu: 'Monitoramento' 
  },
  securityContext: { 
    name: 'Contexto de Segurança',
    menu: 'Contexto de Segurança' 
  },
  searchList: {
    name: 'Alvos de Prospecção',
    menu: 'Alvos de Busca',
    description: 'Configure os segmentos e recortes geográficos que orientam a prospecção inteligente. Cada registro define um alvo de busca por segmento, país, estado e, opcionalmente, cidade. Todos os alvos ativos participam da prospecção em igualdade, sem ordem nem prioridade, e o campo Ativo permite incluir ou retirar um alvo das próximas buscas sem excluí-lo. O Status do Radar mostra, para cada alvo, se ainda há empresas a explorar.'
  },
  service_types: {
    menu: 'Tipos de Serviço'
  },
  services: {
    name: 'Serviços (Site)',
    menu: 'Serviços'
  },
  sites: {
    name: 'Websites',
    menu: 'Websites'
  },
  site_plans: {
    name: 'Planos de Hospedagem',
    menu: 'Planos'
  },
  signup: { 
    name: 'Cadastro',
    menu: 'Cadastro' },
  subscriptions: { 
    name: 'Assinaturas',
    menu: 'Assinaturas' },
  tenantAccess: { 
    name: 'Acessos do Cliente',
    menu: 'Acessos do Cliente' },
  tenantUsage: { 
    name: 'Uso do Cliente',
    menu: 'Uso do Cliente' },
  tags: {
    name: 'Tags de Artigos',
    menu: 'Tags'
  },
  tenants: {
    name: 'Clientes',
    menu: 'Clientes'
  },
  userPricing: { 
    name: 'Precificação por Usuário',
    menu: 'Precificação por Usuário' 
  }
};
